import * as React from "react";

export const SERVICE_ID_DESCRIPTION = (
  <>
    This is only applicable for new services offered on AWS Management Console. Service ID is a number and are generated when you set up your new service in <a href="https://aws-pricing.amazon.com/services" target="_blank" rel="noopener noreferrer">Pricing Console</a>. For example, the Service ID for AWSOutposts is 127675. Please contact your Finance Manager if you need support or reach out to <a href="https://w.amazon.com/bin/view/AWS_CP_Onboarding/Contact_Us" target="_blank" rel="noopener noreferrer">AWS Commerce Platform</a> to onboard your service.
  </>
);
